import React from 'react';
import { Code, Coffee, Pilcrow, Database, FileSpreadsheet, Monitor, BookOpen } from 'lucide-react';

export const buildFoundations = [
    {
      id: 'bf1',
      title: "C++ Programming Course Online - Complete Beginner to Advanced",
      category: "foundations",
      level: "Beginner to Advanced",
      duration: "12 Weeks",
      lectures: "100+",
      mode: "Self Recorded",
      language: "Hindi/English",
              certificate: "Industry Recognized Certificate",
        tests: "10+",
        assignments: "10+",
      price: "1999",
      originalPrice: "3999",
      banner: {
        title: 'C++',
        subtitle: 'Programming',
        background: 'bg-gradient-to-r from-emerald-600 to-green-700',
        Icon: Code
      },
      description: "Master C++ from the ground up, from basic syntax to advanced topics like STL and OOP concepts.",
      overview: "C++ is a powerful programming language that combines the efficiency of C with the flexibility of Object-Oriented Programming (OOP). This course covers the fundamental concepts of C++ and OOP principles, providing a solid foundation for building robust and scalable applications. Whether you are a beginner or looking to enhance your programming skills, this course will guide you through essential topics and hands-on projects.",
      highlights: [
        "Most Premium Course",
        "Live & Recorded Classes",
        "Weekly Live Class for Doubt Solving",
        "50+ Assignments",
        "Assessment via Online Test",
        "Practical Approach",
        "Industry Recognised Certification Course",
        "Access to our Placement Portal"
      ],
      whyOSOP: [
        "India's Most Premium Coding Class",
        "26+ Years of Technology Training",
        "Zero Error Programming",
        "Strong Conceptual & Practical Knowledge"
      ],
      curriculum: [
        { 
          title: 'Introduction to C++', 
          topics: [
            'Overview of C++ and its uses',
            'Basic Input/Output using cout, cin, and endl',
            'Namespaces in C++ and their importance',
            'Reference Variables in C++'
          ] 
        },
        { 
          title: 'C++ Fundamentals', 
          topics: [
            'Function Overloading - concept and examples',
            'std::string Class in C++ - operations, concatenation, and methods',
            'Default Arguments in functions'
          ] 
        },
        { 
          title: 'Object-Oriented Programming (OOP)', 
          topics: [
            'Introduction to OOP and its features',
            'Differences between object-oriented and procedural programming',
            'Features of OOP: Class, Object, Encapsulation, Abstraction, Inheritance, Polymorphism',
            'Access Modifiers - public, private, and protected'
          ] 
        },
        { 
          title: 'Advanced OOP Concepts', 
          topics: [
            'this Pointer in C++ - usage and importance',
            'Scope Resolution Operator with examples',
            'Object Passing and Returning - concept and examples',
            'Constructors and Destructors - types and usage'
          ] 
        },
        { 
          title: 'Special Functions and Members', 
          topics: [
            'Inline Functions - definition and usage',
            'Static Members and Functions - concepts and examples',
            'Dynamic Memory Management - dynamic objects vs. dynamic constructors',
            'Friend Function and Friend Class'
          ] 
        },
        { 
          title: 'Advanced C++ Features', 
          topics: [
            'Operator Overloading - concept and implementation',
            'Inheritance and its Types - applications and examples',
            'Function Overriding and Virtual Functions',
            'Abstract Classes and their significance'
          ] 
        },
        { 
          title: 'OOP Relationships and Concepts', 
          topics: [
            'Generalization and Specialization in OOP',
            'IS-A and HAS-A Relationships',
            'Exception Handling mechanisms',
            'Templates in C++ - function templates and class templates'
          ] 
        },
        { 
          title: 'I/O and File Handling', 
          topics: [
            'C++ IO Stream - introduction and functions',
            'I/O formatting functions and manipulators',
            'File Handling in C++ - file stream classes and operations',
            'Binary mode operations and file I/O',
            'Overloading Insertion and Extraction Operators'
          ] 
        }
      ],
      skillsCovered: 'C++ Programming with OOP principles, Standard Template Library (STL), Exception Handling, File Handling',
      toolsCovered: 'Turbo C++, Visual Studio Code, GCC Compiler',
      certification: 'Training Certification on Successful Completion of the Course'
    },

    {
      id: 'bf5',
      title: "Python for Beginners - Complete Foundation Course",
      category: "foundations",
      level: "Beginner",
      duration: "12 Weeks",
      banner: {
        title: 'Python',
        subtitle: 'for Beginners',
        background: 'bg-gradient-to-r from-yellow-500 to-amber-600',
        Icon: Code
      },
      description: "Start your programming journey with Python - the most beginner-friendly language with comprehensive 12-week curriculum.",
      overview: "Perfect for absolute beginners with no programming experience. This 12-week course offers a structured path to Python mastery with hands-on exercises, real-world projects, and career preparation. Learn Python fundamentals, object-oriented programming, and build practical applications with live sessions and mentorship support.",
      highlights: [
        "12 Weeks of Structured Learning",
        "Live + Recorded Lectures",
        "Interactive Exercises",
        "Real-world Projects",
        "Community + Mentorship",
        "Certification + Placement Support"
      ],
      curriculum: [
        { 
          title: 'Introduction to Python & Programming', 
          topics: [
            'What is Programming?',
            'Why Python?',
            'How Python works internally',
            'Installing Python & First Program',
            'Comments & Syntax',
            'Python Standard & Implementations',
            'Execution Models',
            'I/O Devices, CPU & Memory (Background)'
          ] 
        },
        { 
          title: 'Variables & Data Types', 
          topics: [
            'Variables, id() and type()',
            'Data Types: int, float, string',
            'List, Tuple, Set, Dictionary',
            'Type Conversion',
            'Swapping Variables'
          ] 
        },
        { 
          title: 'Input/Output & Operators', 
          topics: [
            'print() and input()',
            'Arithmetic Operators',
            'Logical Operators',
            'Identity & Membership Operators',
            'Bitwise Operators (Part 1 & 2)',
            'Small Mathematical Programs: AP/GP nth Term, Sum of Natural Numbers, Find Last Digit'
          ] 
        },
        { 
          title: 'Flow Control', 
          topics: [
            'if / else / elif statements',
            'Mini Programs: Even/Odd, Leap Year, Largest of 3 numbers',
            'Calculator Program'
          ] 
        },
        { 
          title: 'Loops in Python', 
          topics: [
            'for, while, range()',
            'Loop Patterns: Square Pattern, Triangle & Inverted Triangle, Pyramid Pattern',
            'Programs: Table Generator, Count Digits, Factorial',
            'GCD & LCM, Fibonacci Numbers, Prime Checking & Divisors'
          ] 
        },
        { 
          title: 'Functions', 
          topics: [
            'Defining and Calling Functions',
            'return, Default & Keyword Arguments',
            'Variable Length Arguments',
            'Parameter Passing',
            'Global Variables',
            'Return Multiple Values',
            'Applications & Examples: First Digit Finder, Prime Factorization'
          ] 
        },
        { 
          title: 'Strings', 
          topics: [
            'Escape Characters & Raw Strings',
            'Formatted Strings',
            'String Operations & Slicing',
            'Pattern Searching',
            'Palindrome Checker',
            'String Reversal',
            'Decimal ↔ Binary Conversion'
          ] 
        },
        { 
          title: 'Lists & Advanced Data Structures', 
          topics: [
            'List Slicing and Indexing',
            'Get Smaller Elements',
            'Separate Even & Odd',
            'List Comprehensions',
            'Mean of a List',
            'Count Distinct Elements',
            'Is List Sorted?'
          ] 
        },
        { 
          title: 'Tuples, Sets & Dictionaries', 
          topics: [
            'Tuple: Properties & Use-Cases',
            'Set: Operations & Uniqueness',
            'Dictionary: Key-Value Structure',
            'Practical Examples and Use-Cases'
          ] 
        },
        { 
          title: 'Object-Oriented Programming (OOP)', 
          topics: [
            'Classes & Objects',
            'Encapsulation, Inheritance',
            'Polymorphism & Abstraction',
            'Operator Overloading',
            'Class/Instance Attributes',
            'Decorators',
            'Abstract Classes'
          ] 
        },
        { 
          title: 'Mini Projects & Coding Challenges', 
          topics: [
            'Project 1: Student Grade Calculator',
            'Project 2: Simple Banking System',
            'Project 3: Quiz App',
            '20+ Output-based MCQs',
            'Practice Coding Challenges'
          ] 
        },
        { 
          title: 'Final Assessment & Career Prep', 
          topics: [
            'Final Capstone Project',
            'Mock Test & Coding Interview Prep',
            'Certificate of Completion',
            'Resume Review + Interview Scheduling',
            'Placement Support Begins'
          ] 
        }
      ],
      skillsCovered: 'Python Programming, Object-Oriented Programming, Data Structures, Algorithm Design, Problem Solving',
      toolsCovered: 'Python 3.x, Jupyter Notebook, VS Code, Git (basics)',
      certification: 'Industry-recognized Certificate upon successful completion',
      jobAssistance: '100% Placement Support with Resume Building and Interview Preparation'
    },
    {
      id: 'bf6',
      title: "Java for Beginners - Programming Fundamentals",
      category: "foundations",
      level: "Beginner",
      duration: "12 Weeks",
      banner: {
        title: 'Java',
        subtitle: 'for Beginners',
        background: 'bg-gradient-to-r from-red-500 to-orange-500',
        Icon: Coffee
      },
      description: "Learn Java programming from scratch with a focus on strong fundamentals.",
      overview: "Designed for beginners, this course builds a solid foundation in Java programming with emphasis on object-oriented concepts.",
      highlights: ["Beginner-friendly approach", "Strong OOP foundation", "Hands-on coding practice"],
      curriculum: [
          { title: 'Introduction to Java', topics: ['Installation', 'Syntax', 'Variables & Methods'] },
          { title: 'OOP Concepts', topics: ['Classes & Objects', 'Inheritance', 'Encapsulation'] },
          { title: 'Practice Projects', topics: ['Simple Applications', 'Problem Solving', 'Best Practices'] }
      ]
    },
    {
      id: 'bf7',
      title: "C for Beginners - Programming Foundation",
      category: "foundations",
      level: "Beginner",
      duration: "12 Weeks",
      banner: {
        title: 'C Programming',
        subtitle: 'for Beginners',
        background: 'bg-gradient-to-r from-gray-600 to-slate-700',
        Icon: Pilcrow
      },
      description: "Build a strong programming foundation with C - the mother of all languages.",
      overview: "C programming is a foundational language for understanding core programming concepts. It is widely used for system programming, embedded systems, and other low-level applications. C provides a strong base to build programming skills, and mastering C helps in understanding the internal architecture of computer systems. This course introduces the basic concepts of C programming, starting from the very fundamentals to more intermediate topics. It is designed for people with no prior programming experience.",
      highlights: [
        'Premium Coding Course',
        'Experienced Trainer',
        'Instructor-Led/Self-Paced Course',
        'Real-time Assignments',
        'Assessment/Online Test',
        'Certification',
        'Placement Assistance'
      ],
      whyOSOP: [
        'India\'s most premium coding class',
        '26+ Years of Technology Training',
        'Zero Error Programming',
        'Strong Conceptual & Practical Knowledge'
      ],
      curriculum: [
        { 
          title: 'Introduction to Computer & C Programming', 
          topics: [
            'Introduction to Computer',
            'Definition and functions of an Operating System',
            'Brief History and Uses of C Programming'
          ] 
        },
        { 
          title: 'C Basics', 
          topics: [
            'Variable & Constant',
            'Introduction to Data Types',
            'Introduction to ASCII',
            'Introduction to Operators and Types',
            'Type Casting in C Programming',
            'Algorithm and Flowchart'
          ] 
        },
        { 
          title: 'C Programming Structure', 
          topics: [
            'Basic C Programs',
            'Types of Errors in C Programming'
          ] 
        },
        { 
          title: 'Conditional Statements', 
          topics: [
            'Conditional Statement (if..else)',
            'Relational (Comparison) Operators',
            'Basic C if..else Programs',
            'Logical Operators in C Programming',
            'Conditional Operator in C Programming',
            'Ladder if...else'
          ] 
        },
        { 
          title: 'Operators in C', 
          topics: [
            'Increment / Decrement Operators',
            'Introduction to Number Systems',
            'Definition and Purpose of Bitwise Operators in C',
            'C Assignment Operators',
            'C Operator Precedence'
          ] 
        },
        { 
          title: 'Looping Statements', 
          topics: [
            'Introduction to Loops & Types',
            'while Loop',
            'do while Loop',
            'for Loop',
            'Nested Loops'
          ] 
        },
        { 
          title: 'Jump Statements & Switch', 
          topics: [
            'Break Statement',
            'Continue Statement',
            'Goto Statement',
            'Introduction to switch Statement'
          ] 
        },
        { 
          title: 'Functions in C Programming', 
          topics: [
            'Introduction to Functions in C Programming',
            'Storage Classes in C Programming',
            'Preprocessor Directives'
          ] 
        },
        { 
          title: 'Pointers in C', 
          topics: [
            'Introduction to Pointers',
            'Types of Pointers',
            'Pointer to Array',
            'Dynamic Memory Management'
          ] 
        },
        { 
          title: 'Arrays & Strings', 
          topics: [
            'Introduction to Array & Its Types',
            'Pointer to Array',
            'Introduction to String',
            'Useful String Functions',
            'Example Code for String Operations'
          ] 
        },
        { 
          title: 'Advanced Topics', 
          topics: [
            'Introduction to 2D Arrays',
            'Example Code for Creating and Adding Elements in a 2D Array',
            'User-Defined Data Types (Structure, Union, Typedef, Enum)',
            'File Handling Operations and Functions'
          ] 
        }
      ],
      skillsCovered: 'C Programming',
      toolsCovered: 'Turbo C++, Vs Code, GCC Compiler',
      certification: 'Training Certification on Successfully Completion of the Course'
    },
    {
      id: 'bf8',
      title: "Computer Basics - Essential Digital Literacy",
      category: "foundations",
      level: "Beginner",
      duration: "12 Weeks",
      banner: {
        title: 'Computer',
        subtitle: 'Basics',
        background: 'bg-gradient-to-r from-indigo-500 to-purple-600',
        Icon: Monitor
      },
      description: "Master essential computer skills and digital literacy for the modern world.",
      overview: "Perfect for beginners who want to become comfortable with computers and technology. Covers everything from basic operations to internet usage.",
      highlights: ["Complete computer literacy", "Internet and email basics", "File management skills"],
      curriculum: [
          { title: 'Computer Fundamentals', topics: ['Hardware & Software', 'Operating Systems', 'File Management'] },
          { title: 'Internet & Communication', topics: ['Web Browsing', 'Email', 'Online Safety'] },
          { title: 'Productivity Tools', topics: ['Word Processing', 'Basic Spreadsheets', 'Presentations'] }
      ]
    },
    {
      id: 'bf9',
      title: "Advanced Excel - Master Data Analysis & Automation",
      category: "foundations",
      level: "Intermediate",
      duration: "12 Weeks",
      banner: {
        title: 'Advanced',
        subtitle: 'Excel',
        background: 'bg-gradient-to-r from-green-600 to-emerald-700',
        Icon: FileSpreadsheet
      },
      description: "Transform your Excel skills with advanced formulas, data analysis, and automation techniques.",
      overview: "Take your Excel skills to the next level with advanced functions, pivot tables, macros, and data visualization techniques.",
      highlights: ["Advanced formulas & functions", "Data analysis & visualization", "Excel automation with VBA"],
      curriculum: [
          { title: 'Advanced Formulas', topics: ['VLOOKUP, INDEX-MATCH', 'Array Formulas', 'Conditional Functions'] },
          { title: 'Data Analysis', topics: ['Pivot Tables', 'Data Validation', 'Charts & Graphs'] },
          { title: 'Automation', topics: ['Macros', 'VBA Basics', 'Automated Reports'] }
      ]
    },
    {
      id: 'bf10',
      title: "SQL Fundamentals - Database Querying Essentials",
      category: "foundations",
      level: "Beginner to Intermediate",
      duration: "12 Weeks",
      banner: {
        title: 'SQL',
        subtitle: 'Fundamentals',
        background: 'bg-gradient-to-r from-blue-600 to-cyan-700',
        Icon: Database
      },
      description: "Master SQL for database querying, data analysis, and backend development.",
      overview: "SQL (Structured Query Language) is the standard language for managing and manipulating relational databases. It is widely used for data retrieval, data insertion, updating, and database schema creation and modification. Understanding SQL is crucial for anyone interested in data management, data analysis, and backend development. This course covers fundamental concepts to advanced SQL functionalities, making it suitable for learners with no prior database experience.",
      highlights: [
        'Premium Coding Course',
        'Experienced Trainer',
        'Instructor-Led/Self-Paced Course',
        'Real-time Assignments',
        'Assessment/Online Test',
        'Certification',
        'Placement Assistance'
      ],
      whyOSOP: [
        'India\'s Most Premium Coding Class',
        '26+ Years of Technology Training',
        'Zero Error Programming',
        'Strong Conceptual & Practical Knowledge'
      ],
      curriculum: [
        { 
          title: 'Introduction to Database', 
          topics: [
            'Definition of Database',
            'Drawbacks of File System'
          ] 
        },
        { 
          title: 'Database Management System (DBMS)', 
          topics: [
            'What is DBMS?',
            'Types of DBMS'
          ] 
        },
        { 
          title: 'MySQL Overview', 
          topics: [
            'Introduction to MySQL',
            'History of MySQL'
          ] 
        },
        { 
          title: 'Introduction to SQL', 
          topics: [
            'What is SQL?',
            'What Can SQL Do?',
            'SQL Commands'
          ] 
        },
        { 
          title: 'SQL Data Types & Commands', 
          topics: [
            'SQL Data Types',
            'SQL Create Statement',
            'Insert Statement'
          ] 
        },
        { 
          title: 'Data Retrieval', 
          topics: [
            'Select Command',
            'Where Clause',
            'SQL Syntax Overview'
          ] 
        },
        { 
          title: 'SQL Operators', 
          topics: [
            'Basic SQL Operators',
            'Logical Operators',
            'ORDER BY Clause',
            'BETWEEN Clause',
            'LIKE Operator and Wildcards'
          ] 
        },
        { 
          title: 'Data Manipulation & Constraints', 
          topics: [
            'Delete Command',
            'Update Command',
            'Primary Key, Unique Key, NOT NULL',
            'Foreign Key'
          ] 
        },
        { 
          title: 'Advanced SQL Features', 
          topics: [
            'Aggregate Functions',
            'Nested Queries',
            'Joins in SQL',
            'Group By Statement'
          ] 
        }
      ],
      skillsCovered: 'SQL Programming',
      toolsCovered: 'MySQL Workbench, Command Line Interface (CLI)',
      certification: 'Training Certification on Successful Completion of the Course'
    },
    {
      id: 'bf11',
      title: "DSA Fundamentals - Data Structures & Algorithms Basics",
      category: "foundations",
      level: "Beginner to Intermediate",
      duration: "12 Weeks",
      banner: {
        title: 'DSA',
        subtitle: 'Fundamentals',
        background: 'bg-gradient-to-r from-violet-600 to-purple-700',
        Icon: BookOpen
      },
      description: "Build a strong foundation in Data Structures and Algorithms for programming interviews and development.",
      overview: "Essential DSA concepts explained in simple terms with practical implementations. Perfect preparation for coding interviews and competitive programming.",
      highlights: ["Interview-focused curriculum", "Language-agnostic concepts", "Problem-solving techniques"],
      curriculum: [
          { title: 'Basic Data Structures', topics: ['Arrays', 'Linked Lists', 'Stacks & Queues'] },
          { title: 'Advanced Structures', topics: ['Trees', 'Graphs', 'Hash Tables'] },
          { title: 'Algorithms', topics: ['Sorting', 'Searching', 'Basic Dynamic Programming'] }
      ]
    }
  ]; 